var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.158,80.14H20.604c-2.757,0-5-2.243-5-5V40.724c0-2.757,2.243-5,5-5h48.555c2.757,0,5,2.243,5,5V75.14    C74.158,77.896,71.915,80.14,69.158,80.14z M20.604,37.724c-1.654,0-3,1.346-3,3V75.14c0,1.654,1.346,3,3,3h48.555    c1.654,0,3-1.346,3-3V40.724c0-1.654-1.346-3-3-3H20.604z",
    stroke: "#2771bb"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.218,68.261H77.4c-0.553,0-1-0.447-1-1s0.447-1,1-1h3.817c1.554,0,2.817-1.346,2.817-3V28.846c0-1.654-1.346-3-3-3    H32.48c-1.654,0-3,1.265-3,2.818v3.818c0,0.553-0.447,1-1,1s-1-0.447-1-1v-3.818c0-2.657,2.243-4.818,5-4.818h48.555    c2.757,0,5,2.243,5,5v34.415C86.035,66.018,83.874,68.261,81.218,68.261z",
    stroke: "#2771bb"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 66.919,
    cy: 41.98,
    r: 1.5,
    stroke: "#2771bb"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 62.283,
    cy: 41.98,
    r: 1.5,
    stroke: "#2771bb"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 57.647,
    cy: 41.98,
    r: 1.5,
    stroke: "#2771bb"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.166,48.582H20.599c-0.553,0-1-0.447-1-1s0.447-1,1-1h48.567c0.553,0,1,0.447,1,1S69.719,48.582,69.166,48.582z",
    stroke: "#2771bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal);
export default __webpack_public_path__ + "static/media/modal.8face195fa128a7295b9430051867212.svg";
export { ForwardRef as ReactComponent };